import React, { SyntheticEvent, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useImmer } from "use-immer";

import { ExperienceHeader } from "../../features/experienceTests/pages/home/components/ExperimentsHeader";
import { useViewPage } from "../../hooks/mixpanel";

import { OfferPersonalizationTabs } from "./LibraryTabs/OfferPersonalizationTabs";
import { TestTabs } from "./LibraryTabs/TestTabs";

export const WidgetLibraryBody = () => {
  const location = useLocation();
  const [tabValue, setTabValue] = useImmer<number>(0);

  const isCampaigns = useMemo(() => {
    return location.pathname.includes("experiences");
  }, [location.pathname]);

  const onChange = (event: SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    if (!isCampaigns) {
      setTabValue(0);
    }
  }, [isCampaigns]);

  return (
    <>
      <ExperienceHeader
        title={isCampaigns ? "Offer Widgets" : "Site-Wide Widgets"}
        articleLink={""}
        linkText={""}
      />
      {isCampaigns ? (
        <OfferPersonalizationTabs tabValue={tabValue} onChange={onChange} />
      ) : (
        <TestTabs tabValue={tabValue} onChange={onChange} />
      )}
    </>
  );
};
